import { Plus } from "lucide-react";

import ButtonV2 from "../../../../components/ui/button/v2";
import { Account } from "../../../../api/accounts";
import AccountRow from "./AccountRow";
import { CollectionModal } from "./SectionShell";

export interface CreateCaseAddAccountsModalProps {
  accounts: Account[];
  onChange: (next: Account[]) => void;
  showErrors: boolean;
  onClose: () => void;
  onDone: () => void;
  onAdd: () => void;
  addEnabled: boolean;
}

const CreateCaseAddAccountsModal: React.FC<CreateCaseAddAccountsModalProps> = ({
  accounts,
  onChange,
  showErrors,
  onClose,
  onDone,
  onAdd,
  addEnabled,
}) => {
  const change = (accountNumber: string, next: Account) =>
    onChange(accounts.map((a) => (a.account_number === accountNumber ? next : a)));
  const remove = (accountNumber: string) =>
    onChange(accounts.filter((a) => a.account_number !== accountNumber));

  return (
    <CollectionModal title="Accounts" onClose={onClose} onDone={onDone}>
      <div className="flex flex-col gap-4">
        {accounts.map((row, index) => (
          <AccountRow
            key={row.account_number}
            value={row}
            accounts={accounts}
            showErrors={showErrors}
            showLabels={index === 0}
            onChange={(next) => change(row.account_number, next)}
            onRemove={() => remove(row.account_number)}
            canRemove={accounts.length > 1}
          />
        ))}
        <ButtonV2
          variant="ghost"
          size="sm"
          disabled={!addEnabled}
          onClick={onAdd}
          className="text-[#3551F3] bg-transparent self-start disabled:opacity-40"
          prefix={<Plus width="16" height="16" />}
        >
          Add Account
        </ButtonV2>
      </div>
    </CollectionModal>
  );
};

export default CreateCaseAddAccountsModal;
